import React from "react";
import CookieConsent from "react-cookie-consent";
import { connect } from "react-redux";
import get from "lodash/get";
import { string } from "prop-types";

import "./gdprPolicy.m.css";

const GdprPolicy = ({ domainLink }) => {
  return (
    <div>
      <CookieConsent
        location="bottom"
        buttonText="OK"
        containerClasses="gdpr-wrapper"
        style={{
          background: "#001246",
          fontSize: "16px",
          textAlign: "center",
          padding: "16px",
          fontFamily: "Roboto, Arial, Helvetica, sans-serif",
        }}
        buttonWrapperClasses="ok-button-link"
        buttonStyle={{ background: "#0099ff", color: "#fff", fontSize: "18px", marginTop: "0px" }}
      >
        We use cookies to tailor your experience, measure site performance and present relevant advertisements. By
        clicking the “ok” button, you agree that cookies can be placed in accordance with our{" "}
        <a
          href={`${domainLink}/privacy-policy`}
          rel="noreferrer"
          target="_blank"
          style={{ textDecoration: "underline", color: "#fff" }}
        >
          Privacy Policy
        </a>
        .
      </CookieConsent>
    </div>
  );
};

GdprPolicy.propTypes = {
  domainLink: string,
};

const mapStateToProps = (state) => ({
  domainLink: get(state, ["qt", "currentHostUrl"], {}),
});

export default connect(mapStateToProps, "")(GdprPolicy);
